import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'
import Text from 'components/common/Text/Text'
import { A } from 'components/common/Link/Link'
import { DONE_STEP_ASSET } from 'constant'
import withScrollToAnchor from 'components/common/hoc/withScrollToAnchor'

const ProgressLineElement = ({
  className,
  title,
  button,
  isDone,
  onClick,
  scrollToAnchorHandler,
  ...props
}) =>
  <Wrapper
    data-at-progress-element
    className={ className }
    button={ button }
    onClick={ button ? onClick : scrollToAnchorHandler }
    { ...props }>
    {
      !button ?
        <Fragment>
          {
            isDone ?
              <RoundIcon data-cta inline small asset={ DONE_STEP_ASSET } /> :
              <RoundIcon data-cta inline small { ...props } />
          }
          <A prevent>
            <LabelText follow_link inline>{ title }</LabelText>
          </A>
        </Fragment> :
        <LabelText button follow_link inline>{ title }</LabelText>
    }
  </Wrapper>

ProgressLineElement.propTypes = {
  alternative: PropTypes.string,
  asset: PropTypes.string,
  button: PropTypes.bool,
  className: PropTypes.string,
  condition: PropTypes.bool,
  filled: PropTypes.bool,
  isDone: PropTypes.bool,
  onClick: PropTypes.func,
  scrollToAnchorHandler: PropTypes.func,
  title: PropTypes.string
}

export default withScrollToAnchor(ProgressLineElement)

const Wrapper = styled.div`
  position: relative;
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
  ${Mixin.responsive('width', '20%', '16%')}
  ${Mixin.responsive('height', '60px', '50px')}
  ${Mixin.responsive('padding', '0 36px', '0 6px 0 26px')}
  ${Mixin.responsive('text-align', 'left', 'center')}

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0;
    z-index: 2;
    border: 30px solid ${Theme.colors.transparent};
    border-left: 15px solid ${Theme.colors.light_grey};
    ${Media.mobile`
      border-width: 25px;
      border-left-width: 13px;
    `}
  }

  &::after {
    border-left-color: ${Theme.colors.white};
    ${Mixin.responsive('right', '-44px', '-38px')}
  }

  &::before {
    ${Mixin.responsive('right', '-45px', '-39px')}
  }

  &:last-child::before,
  &:last-child::after {
    display: none;
  }

  ${props => props.condition && css`
    background-color: ${Theme.colors.off_white};

    &::after {
      border-left-color: ${Theme.colors.off_white};
    }
  `}

  ${props => props.button && css`
    background-color: ${Theme.colors.red};
    text-align: center;
    ${Mixin.responsive('min-width', '165px', '85px')}
    ${Media.mobile`
      width: 20%;
      padding: 0 6px 0 18px;
    `}
  `}
`
// TODO: Consider removing last mixin
const LabelText = styled(Text)`
  margin-left: 10px;
  cursor: pointer;
  ${Mixin.font.GothamBold(12, 600)}
  ${Mixin.desktopOnly()}
  ${props => props.button && css`
    display: inline-block !important;
    margin: 0;
    color: ${Theme.colors.white};
    ${Mixin.responsive('font-size', '18px', '14px')}
  `}
`
